class BlockColors extends HTMLElement {
    connectedCallback() {
      this.updateColor();
    }
  
    updateColor() {
      const colorElement = this.querySelector(".type-color-answer");
      const listItems = Array.from(document.querySelectorAll("li"));
      const colorListItem = listItems.find((li) =>
        li.textContent.includes("Cor:")
      );
      if (colorElement && colorListItem) {
        const color = colorListItem.textContent.split(": ")[1] || "Branco";
        colorElement.textContent = color;
      }
    }
  }
  
  customElements.define("block-colors", BlockColors);